import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";

const HAFHMessagesDisplay = ({ t, role }) => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();

  const userId = authState?.user?._id;
  const userCode = authState?.user?.think5whyscode;
  const userName = authState?.user?.name;

  const userRole = authState?.user?.role || "STUDENT";

  const [receiverCode, setReceiverCode] = useState("");
  const [receiverRole, setReceiverRole] = useState("");
  const [visibleToRoles, setVisibleToRoles] = useState([]);
  const [hiddenForUsers, setHiddenForUsers] = useState([]);

  const [subject, setSubject] = useState("");
  const [messageType, setMessageType] = useState("INFO");

  const [visibleToAll, setVisibleToAll] = useState(true);
  const [needReply, setNeedReply] = useState(false);
  const [isCommon, setIsCommon] = useState(false);
  const [isImportant, setIsImportant] = useState(false);
  const [isSOS, setIsSOS] = useState(false);
  const [isPinned, setIsPinned] = useState(false);

  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const today = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [replyText, setReplyText] = useState("");
  const [isReplyVisibleToAll, setIsReplyVisibleToAll] = useState(false);

  const [showPostBox, setShowPostBox] = useState(false);
  const [newMessage, setNewMessage] = useState("");

  const hasFetched = useRef(false);

  // =========================
  // FETCH MESSAGES
  // =========================
  const fetchMessages = async () => {
    try {
      const config = {
        url: "/hafh/communication/messages/my",
        method: "post",
        data: { userId },
        headers: { Authorization: authState.token },
      };

      const res = await fetchData(config, {
        showSuccessToast: false,
      });

      if (res?.status) setMessages(res.records || []);
    } catch (err) {
      console.error("Message fetch error:", err);
    }
  };

  useEffect(() => {
    if (!userId) return;
    if (hasFetched.current) return;

    hasFetched.current = true;
    fetchMessages();
  }, [userId]);

  const filteredMessages = useMemo(() => {
    return [...messages]
      .filter((m) => {
        const msgDate = new Date(m.dateCreated).toISOString().split("T")[0];

        const matchesFrom = !fromDate || msgDate >= fromDate;
        const matchesTo = !toDate || msgDate <= toDate;

        return matchesFrom && matchesTo;
      })
      .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));
  }, [messages, fromDate, toDate]);

  const handleSelectMessage = (msg) => {
    if (selectedMessage?._id === msg._id) {
      setSelectedMessage(null);
      setReplyText("");
      return;
    }

    setSelectedMessage(msg);
    setReplyText("");
  };

  // const handleReply = async () => {
  //   if (!replyText || !selectedMessage) return;

  //   try {
  //     const config = {
  //       url: `/hafh/communication/messages/reply/${selectedMessage._id}`,
  //       method: "put",
  //       data: {
  //         replyMessage: replyText,
  //         isReplyVisibleToAll,
  //       },
  //       headers: { Authorization: authState.token },
  //     };

  //     const res = await fetchData(config);

  //     if (res?.status) {
  //       setReplyText("");
  //       fetchMessages();
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const handleReply = async () => {
    if (!replyText?.trim() || !selectedMessage) return;

    try {
      const config = {
        url: `/hafh/communication/messages/reply/${selectedMessage._id}`,
        method: "put",
        data: {
          repliedBy: userId,
          repliedByCode: userCode,
          repliedByName: userName,
          replyerRole: userRole,
          replyMessage: replyText,
          isReplyVisibleToAll,
        },
        headers: { Authorization: authState.token },
      };

      const res = await fetchData(config);

      if (res?.status) {
        setReplyText("");
        setIsReplyVisibleToAll(false);

        // await fetchMessages();

        // // refresh selected message
        // const updatedMessage =
        //   (res?.record) ||
        //   (res?.updatedRecord) ||
        //   messages.find((m) => m._id === selectedMessage._id);

        // if (updatedMessage) {
        //   setSelectedMessage(updatedMessage);
        // }
        if (res?.record) {
          setSelectedMessage(res.record);
        }

        fetchMessages();
      }
    } catch (err) {
      console.error(err);
    }
  };



  // const handlePostMessage = async () => {
  //   console.log(newMessage);
  //   if (!newMessage?.trim()) return;

  //   try {
  //     const config = {
  //       url: "/hafh/communication/messages/send",
  //       method: "post",
  //       data: {
  //         userId: userId,
  //         userCode: userCode,
  //         userName: userName,
  //         messengerRole: userRole,
  //         visibleToAll,
  //         receiverCode,
  //         receiverRole,
  //         visibleToRoles,
  //         hiddenForUsers,
  //         subject,
  //         message: newMessage,
  //         messageType,
  //         needReply,
  //         isReply: false,
  //         repliedBy: null,
  //         repliedByName: "",
  //         replyerRole: "",
  //         replyMessage: "",
  //         replyDate: null,
  //         isReplyVisibleToAll: null,
  //         isComm: visibleToAll,
  //         isImportant,
  //         isSOS,
  //         isPinned,
  //         isRead: false, 
  //         readBy: null,
  //         isActive: true,
  //         dateCreated: Date.now,
  //         updatedAt: Date.now
  //       },
  //       headers: { Authorization: authState.token },
  //     };

  //     const res = await fetchData(config);

  //     if (res?.status) {
  //       setNewMessage("");
  //       setReceiverCode("");
  //       setSubject("");
  //       setShowPostBox(false);
  //       fetchMessages();
  //     }
  //   } catch (err) {
  //     console.error("Post message error:", err);
  //   }
  // };

  const handlePostMessage = async () => {
    if (!newMessage?.trim()) return;

    try {
      const config = {
        url: "/hafh/communication/messages/send",
        method: "post",
        data: {
          userId,
          userCode,
          userName,
          messengerRole: userRole,

          visibleToAll,
          targetUserCode: receiverCode,
          targetRole: receiverRole || "ALL",
          visibleToRoles,
          hiddenForUsers,

          subject,
          message: newMessage,
          messageType,

          needReply,

          replies: [],
          totalReplies: 0,
          lastReplyDate: null,
          lastReplyByName: "",

          isCommon,
          isImportant,
          isSOS,
          isPinned,

          isRead: false,
          readBy: [],

          isActive: true,
        },
        headers: { Authorization: authState.token },
      };

      const res = await fetchData(config);

      if (res?.status) {
        setNewMessage("");
        setReceiverCode("");
        setReceiverRole("");
        setSubject("");
        setShowPostBox(false);

        fetchMessages();
      }
    } catch (err) {
      console.error("Post message error:", err);
    }
  };

  return (
    <div className="bg-gray-800 p-4 rounded-xl text-white space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-cyan-200 text-sm lg:text-lg">
          {t("messages")} ({filteredMessages.length})
        </h2>

        <button
          onClick={() => setShowPostBox(true)}
          className="px-3 py-2 rounded text-xs lg:text-sm w-36 bg-blue-600 hover:bg-blue-500"
        >
          Post Message
        </button>
      </div>

      {showPostBox && (
        <div className="bg-gray-900 p-4 rounded-xl space-y-3 border border-blue-500">
          <div className="flex flex-wrap gap-3 text-xs lg:text-sm">
            <label className="flex items-center gap-2 bg-cyan-900/40 border border-cyan-600 px-3 py-2 rounded-xl cursor-pointer hover:bg-cyan-800/50 transition-all duration-200">
              <input
                type="checkbox"
                checked={visibleToAll}
                onChange={(e) => setVisibleToAll(e.target.checked)}
                className="accent-cyan-400 w-4 h-4"
              />
              <span className="font-medium text-cyan-100">
                🌍 Visible To All
              </span>
            </label>

            <label className="flex items-center gap-2 bg-yellow-900/40 border border-yellow-600 px-3 py-2 rounded-xl cursor-pointer hover:bg-yellow-800/50 transition-all duration-200">
              <input
                type="checkbox"
                checked={needReply}
                onChange={(e) => setNeedReply(e.target.checked)}
                className="accent-yellow-400 w-4 h-4"
              />
              <span className="font-medium text-yellow-100">
                💬 Need Reply
              </span>
            </label>

            <label className="flex items-center gap-2 bg-red-900/40 border border-red-600 px-3 py-2 rounded-xl cursor-pointer hover:bg-red-800/50 transition-all duration-200">
              <input
                type="checkbox"
                checked={isImportant}
                onChange={(e) => setIsImportant(e.target.checked)}
                className="accent-red-400 w-4 h-4"
              />
              <span className="font-medium text-red-100">
                ⭐ Important
              </span>
            </label>

            <label className="flex items-center gap-2 bg-pink-900/40 border border-pink-600 px-3 py-2 rounded-xl cursor-pointer hover:bg-pink-800/50 transition-all duration-200">
              <input
                type="checkbox"
                checked={isSOS}
                onChange={(e) => setIsSOS(e.target.checked)}
                className="accent-pink-400 w-4 h-4"
              />
              <span className="font-medium text-pink-100">
                🚨 SOS
              </span>
            </label>

            <label className="flex items-center gap-2 bg-purple-900/40 border border-purple-600 px-3 py-2 rounded-xl cursor-pointer hover:bg-purple-800/50 transition-all duration-200">
              <input
                type="checkbox"
                checked={isPinned}
                onChange={(e) => setIsPinned(e.target.checked)}
                className="accent-purple-400 w-4 h-4"
              />
              <span className="font-medium text-purple-100">
                📌 Pinned
              </span>
            </label>

          </div>
          <div className="flex flex-wrap gap-2 text-xs lg:text-sm">
            <input
              type="text"
              placeholder="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="w-full px-2 py-1 bg-gray-700 rounded text-xs lg:text-sm"
            />

            <select
              value={messageType}
              onChange={(e) => setMessageType(e.target.value)}
              className="w-24 lg:w-32 px-2 py-1 bg-gray-700 rounded text-xs lg:text-sm"
            >
              <option value="INFO">INFO</option>
              <option value="WARNING">WARNING</option>
              <option value="ALERT">ALERT</option>
              <option value="SOS">SOS</option>
              <option value="SYSTEM">SYSTEM</option>
              <option value="APPROVAL">APPROVAL</option>
            </select>
          </div>

          <textarea
            placeholder="Write message..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            className="w-full p-2 bg-gray-700 rounded text-xs lg:text-sm"
            style={{height: "250px"}}
          />
                    
          <input
            type="text"
            placeholder="Receivers Code (optional)"
            value={receiverCode}
            onChange={(e) => setReceiverCode(e.target.value)}
            className="w-full p-2 bg-gray-700 rounded text-xs lg:text-sm"
          />

          {/* ACTIONS */}
          <div className="flex gap-2">
            <button
              onClick={handlePostMessage}
              disabled={!newMessage?.trim()}
              className={`px-3 py-2 rounded text-sm w-32 ${
                newMessage
                  ? "bg-green-600 hover:bg-green-500"
                  : "bg-gray-600 opacity-50"
              }`}
            >
              Post
            </button>

            <button
              onClick={() => setShowPostBox(false)}
              className="px-3 py-2 rounded text-sm w-32 bg-red-600 hover:bg-red-500"
            >
              Cancel
            </button>
          </div>

        </div>
      )}

      {/* FILTERS */}
      <div className="bg-gray-900 p-3 rounded-xl grid grid-cols-2 gap-2">
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          className="bg-gray-700 p-2 rounded text-xs lg:text-sm"
        />
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          className="bg-gray-700 p-2 rounded text-xs lg:text-sm"
        />
      </div>

      {/* LIST */}
      <div className="space-y-2">
        {filteredMessages.map((m) => {
          const isSelected = selectedMessage?._id === m._id;

          return (
            <div
              key={m._id}
              onClick={() => handleSelectMessage(m)}
              className={`cursor-pointer p-3 rounded transition-all duration-200 border ${
                isSelected
                  ? "bg-cyan-900/40 border-cyan-500"
                  : "bg-gray-700 hover:bg-gray-600 border-transparent"
              }`}
            >
              <div className="flex justify-between items-start gap-2">
                <div className="text-xs text-gray-300">
                  {new Date(m.dateCreated).toLocaleString()}
                </div>

                <div className="flex flex-wrap gap-1">
                  {m.isPinned && <span className="text-xs">📌</span>}
                  {m.isImportant && <span className="text-xs">⭐</span>}
                  {m.isSOS && <span className="text-xs">🚨</span>}
                  {m.needReply && <span className="text-xs">💬</span>}
                </div>
              </div>

              {m.subject && (
                <div className="text-cyan-200 text-xs lg:text-sm font-semibold mt-1">
                  {m.subject}
                </div>
              )}

              <div className="text-xs lg:text-sm mt-1">
                {m.message}
              </div>

              {/* {m.replies?.length > 0 && (
                <div className="text-[10px] lg:text-xs text-green-300 mt-2">
                  💬 {m.replies.length} Replies
                </div>
              )} */}
              {m.replies?.length > 0 && (
                <div className="text-[10px] lg:text-xs text-green-300 mt-2">
                  💬 {m.replies.length} {m.replies.length === 1 ? "Reply" : "Replies"}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* DETAIL + REPLY */}
      {selectedMessage && (
        <div className="bg-gray-900 p-4 rounded-xl border border-cyan-500 space-y-4">

          {/* ORIGINAL MESSAGE */}
          <div className="bg-gray-800 rounded-xl p-3 border border-gray-700">
            <div className="flex justify-between items-center">
              <div className="text-cyan-200 font-semibold text-sm lg:text-base">
                📩 Message
              </div>

              <div className="text-[10px] lg:text-xs text-gray-400">
                {new Date(selectedMessage.dateCreated).toLocaleString()}
              </div>
            </div>

            {selectedMessage.subject && (
              <div className="mt-2 text-yellow-300 font-semibold text-sm">
                {selectedMessage.subject}
              </div>
            )}

            <div className="mt-2 text-xs lg:text-sm whitespace-pre-wrap">
              {selectedMessage.message}
            </div>
          </div>

          {/* REPLIES */}
          {/* <div className="space-y-2">
            <div className="text-cyan-200 font-semibold text-sm lg:text-base">
              💬 Replies
            </div>

            {selectedMessage?.replies?.length > 0 ? (
              selectedMessage.replies.map((reply, index) => (
                <div
                  key={index}
                  className="bg-gray-800 border border-gray-700 rounded-xl p-3"
                >
                  <div className="flex justify-between items-center">
                    <div className="text-xs text-cyan-300 font-semibold">
                      👤 {reply?.repliedByName || "User"}
                    </div>

                    <div className="text-[10px] lg:text-xs text-gray-400">
                      {reply?.replyDate
                        ? new Date(reply.replyDate).toLocaleString()
                        : ""}
                    </div>
                  </div>

                  <div className="mt-2 text-xs lg:text-sm whitespace-pre-wrap">
                    {reply?.replyMessage}
                  </div>

                  <div className="mt-2 text-[10px] lg:text-xs">
                    {reply?.isReplyVisibleToAll ? (
                      <span className="text-green-300">
                        🌍 Visible To All
                      </span>
                    ) : (
                      <span className="text-yellow-300">
                        🔒 Hidden Reply
                      </span>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-xs text-gray-400 bg-gray-800 p-3 rounded-xl">
                No replies yet.
              </div>
            )}
          </div> */}

          {/* REPLIES */}
          <div className="space-y-2">
            <div className="text-cyan-200 font-semibold text-sm lg:text-base">
              💬 Replies ({Array.isArray(selectedMessage?.replies)
              ? selectedMessage.replies.length
              : 0})
            </div>

            {selectedMessage?.replies?.length > 0 ? (
              [...selectedMessage.replies]
                .sort((a, b) => new Date(b.replyDate) - new Date(a.replyDate))
                .map((reply, index) => (
                  <div
                    key={reply?._id || index}
                    className="bg-gray-800 border border-gray-700 rounded-xl p-3"
                  >
                    <div className="flex justify-between items-center gap-2">
                      <div>
                        <div className="text-xs text-cyan-300 font-semibold">
                          👤 {reply?.repliedByName || "User"}
                        </div>

                        {reply?.replyerRole && (
                          <div className="text-[10px] text-gray-400">
                            {reply.replyerRole}
                          </div>
                        )}
                      </div>

                      <div className="text-[10px] lg:text-xs text-gray-400">
                        {reply?.replyDate
                          ? new Date(reply.replyDate).toLocaleString()
                          : ""}
                      </div>
                    </div>

                    <div className="mt-3 text-xs lg:text-sm whitespace-pre-wrap text-gray-100">
                      {reply?.replyMessage}
                    </div>

                    <div className="mt-3 flex justify-between items-center">
                      <div className="text-[10px] lg:text-xs">
                        {reply?.isReplyVisibleToAll ? (
                          <span className="text-green-300">
                            🌍 Visible To All
                          </span>
                        ) : (
                          <span className="text-yellow-300">
                            🔒 Hidden Reply
                          </span>
                        )}
                      </div>

                      {reply?.isEdited && (
                        <span className="text-[10px] text-gray-500 italic">
                          Edited
                        </span>
                      )}
                    </div>
                  </div>
                ))
            ) : (
              <div className="text-xs text-gray-400 bg-gray-800 p-3 rounded-xl">
                No replies yet.
              </div>
            )}
          </div>

          {/* REPLY BOX */}
          <div className="bg-gray-800 rounded-xl p-3 border border-gray-700 space-y-3">
            <div className="text-cyan-200 font-semibold text-sm lg:text-base">
              ✍️ Post Reply
            </div>

            <textarea
              value={replyText}
              onChange={(e) => setReplyText(e.target.value)}
              placeholder="Write your reply here..."
              style={{ height: "150px" }}
              className="w-full p-2 bg-gray-700 rounded text-xs lg:text-sm"
            />

            <div className="flex flex-wrap justify-between items-center gap-3">

              {/* VISIBILITY TOGGLE */}
              <div className="flex items-center gap-3">
                <span className="text-xs lg:text-sm font-semibold text-gray-300">
                  {isReplyVisibleToAll
                    ? "🌍 Public Reply"
                    : "🔒 Hidden Reply"}
                </span>

                <button
                  type="button"
                  onClick={() =>
                    setIsReplyVisibleToAll(!isReplyVisibleToAll)
                  }
                  className={`relative w-14 h-7 rounded-full transition-all duration-300 ${
                    isReplyVisibleToAll
                      ? "bg-green-500 shadow-lg shadow-green-500/40"
                      : "bg-gray-600"
                  }`}
                >
                  <div
                    className={`absolute top-1 w-5 h-5 rounded-full bg-white transition-all duration-300 ${
                      isReplyVisibleToAll ? "left-8" : "left-1"
                    }`}
                  />
                </button>
              </div>

              {/* POST BUTTON */}
              <button
                onClick={handleReply}
                disabled={!replyText?.trim()}
                className={`px-4 py-2 rounded-lg text-xs lg:text-sm font-semibold transition-all duration-200 ${
                  replyText?.trim()
                    ? "bg-green-600 hover:bg-green-500"
                    : "bg-gray-600 opacity-50 cursor-not-allowed"
                }`}
              >
                🚀 Post Reply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HAFHMessagesDisplay;